import { motion } from 'framer-motion';
import { Scale, FileCheck, Clock, Shield } from 'lucide-react';

const cards = [
  {
    icon: FileCheck,
    title: 'Ventes publiques & Biddit',
    description:
      'Organisation des visites groupées et gestion des accès selon vos contraintes légales.',
  },
  {
    icon: Clock,
    title: 'Ventes de gré à gré',
    description:
      'Prise en charge complète des visites individuelles pour vos mandats classiques.',
  },
  {
    icon: Shield,
    title: 'Successions & indivisions',
    description:
      'Coordination avec les héritiers et gestion des accès dans des contextes sensibles.',
  },
];

export function TargetAudience() {
  return (
    <section id="cible" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-50 text-gold-700 text-sm font-medium border border-gold-200 mb-6"
          >
            <Scale className="w-4 h-4" />
            Exclusivement pour les notaires
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl font-display font-bold text-navy-600 mb-6"
          >
            Le partenaire des{' '}
            <span className="gradient-text">études notariales</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="text-xl text-navy-300"
          >
            Nous comprenons les spécificités de votre métier et adaptons nos services à chaque situation.
          </motion.p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {cards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="rounded-2xl bg-white border border-navy-100 shadow-sm p-8 hover:shadow-md hover:border-gold-300/50 transition-all"
            >
              <div className="w-12 h-12 rounded-xl bg-gold-50 flex items-center justify-center mb-5">
                <card.icon className="w-6 h-6 text-gold-600" />
              </div>
              <h3 className="text-xl font-display font-semibold text-navy-600 mb-3">
                {card.title}
              </h3>
              <p className="text-navy-300 leading-relaxed">{card.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Bottom message */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center text-navy-400 mt-12 text-lg"
        >
          <span className="font-semibold text-navy-600">Un seul interlocuteur</span>{' '}
          pour simplifier votre quotidien et vous permettre de vous concentrer sur votre cœur de métier.
        </motion.p>
      </div>
    </section>
  );
}
